export default class DtoSTEPAssociatedIndustry {
    constructor(obj) {
        this.idStation = obj.idStation
        this.code = obj.code
        this.startDate = obj.startDate
        this.endDate = obj.endDate
        this.comment = obj.comment
    }
}